import { render, staticRenderFns } from "./WPGAhome.vue?vue&type=template&id=123d4c6c&scoped=true"
import script from "./WPGAhome.vue?vue&type=script&lang=js"
export * from "./WPGAhome.vue?vue&type=script&lang=js"
import style0 from "./WPGAhome.vue?vue&type=style&index=0&id=123d4c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d4c6c",
  null
  
)

export default component.exports